import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 text-left transition-colors duration-300 ease-in-out" }

import { ref } from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";

type Variant = "brown-outline" | "active" | "active-outline" | "white-outline";


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenButton',
  props: {
    label: {},
    type: {},
    hoverType: {},
    hoverContainer: {}
  },
  emits: ["clickedBtn"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isHovered = ref(false);

const emit = __emit;

function clicked() {
  emit("clickedBtn");
}

const btnClasses: Record<Variant, string> = {
  "brown-outline": "border border-brown text-brown",
  active: "bg-active text-white",
  "active-outline": "border border-active text-active",
  "white-outline": "border border-white text-white",
};

const btnHoverClasses: Record<Variant, string> = {
  "active-outline": "border hover:border-active hover:text-active",
  "brown-outline": "border hover:border-brown hover:text-brown",
  "white-outline": "border hover:border-white hover:text-white",
  active: "hover:bg-active hover:text-white hover:border-active",
};

const iconClasses: Record<Variant, string> = {
  "active-outline": "bg-active text-white",
  "brown-outline": "bg-brown text-white",
  "white-outline": "bg-white text-brown",
  active: "bg-white text-active",
};

const iconHoverClasses: Record<Variant, string> = {
  "active-outline": "group-hover:bg-active group-hover:text-white",
  "brown-outline": "group-hover:bg-brown group-hover:text-white",
  "white-outline": "group-hover:bg-white group-hover:text-brown",
  active: "group-hover:bg-white group-hover:text-active",
};

const btnHoverContainerClasses: Record<Variant, string> = {
  "active-outline":
    "group-hover/container:[&:not(:hover)]:border-active group-hover/container:[&:not(:hover)]:text-active",
  "brown-outline":
    "group-hover/container:[&:not(:hover)]:border-brown group-hover/container:[&:not(:hover)]:text-brown",
  "white-outline":
    "group-hover/container:[&:not(:hover)]:border-white group-hover/container:[&:not(:hover)]:text-white",
  active:
    "group-hover/container:[&:not(:hover)]:bg-active group-hover/container:[&:not(:hover)]:text-white group-hover/container:[&:not(:hover)]:border-active",
};

const iconHoverContainerClasses: Record<Variant, string> = {
  "active-outline":
    "group-hover/container:[&:not(:hover)]:bg-active group-hover/container:[&:not(:hover)]:text-white",
  "brown-outline":
    "group-hover/container:[&:not(:hover)]:bg-brown group-hover/container:[&:not(:hover)]:text-white",
  "white-outline":
    "group-hover/container:[&:not(:hover)]:bg-white group-hover/container:[&:not(:hover)]:text-brown",
  active:
    "group-hover/container:[&:not(:hover)]:bg-white group-hover/container:[&:not(:hover)]:text-active",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHovered.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = false)),
    onClick: clicked,
    class: _normalizeClass(["group btn", [
      btnClasses[props.type],
      props.hoverContainer &&
        !isHovered.value &&
        btnHoverContainerClasses[props.hoverContainer],
      props.hoverType && btnHoverClasses[props.hoverType],
    ]])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["btn-text", [
        iconClasses[props.type],
        props.hoverContainer &&
          !isHovered.value &&
          iconHoverContainerClasses[props.hoverContainer],
        props.hoverType && iconHoverClasses[props.hoverType],
      ]])
    }, [
      _createVNode(ArrowIcon, { class: "transition-transform duration-300 ease-in-out group-hover:rotate-45" })
    ], 2)
  ], 34))
}
}

})